<template>
    <section class="paint-top-wrapper">
        <div class="paint-left">
            <div class="shape"></div>
            <div class="shape"></div>
            <span class="top-span1">Lorem ipsum dolor sit.</span>
            <span class="top-span2">Lorem ipsum dolor, sit amet consectetur adipisicing elit. Tempora eaque odit quisquam
                nesciunt illum ut iure ea. Blanditiis, accusantium incidunt.</span>
            <span class="top-span2">Lorem ipsum dolor sit amet consectetur adipisicing elit. Rem quidem nobis culpa
                ea?</span>
            <span class="top-span2">Lorem ipsum dolor sit amet, consectetur adipisicing elit. Numquam dolorum quibusdam
                ullam error repellat esse, consequuntur tempore consectetur, vero ratione et doloremque debitis! Excepturi
                sunt quo impedit nulla, explicabo aliquid nostrum tempore?</span>
        </div>
        <div class="paint-right top-scaff-img1"></div>
    </section>
</template>

<script>
export default {
    name: 'scaffolding-top',
}
</script>

<style lang="scss">
.top-scaff-img1 {
    background-image: url('../../../public/img/scaffolding/1.jpg');
}
</style>